import { useEmailOnStart } from "./use-email-on-start";
import { useCallOnStart } from "./use-call-on-start";

/**
 * This component is used to start functionalities when the account details page is initialized and loaded
 * like starting a call or opening an email sidebar
 */
export const AutoStart = () => {
  useCallOnStart();
  useEmailOnStart();

  return null;
};
